"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var numberFormat_1 = __importDefault(require("../../utils/numberFormat"));
var getCurrencySymbol_1 = __importDefault(require("../../utils/getCurrencySymbol"));
var propTypes = {
    price: prop_types_1.default.number,
    currency: prop_types_1.default.string,
    hasDiscounts: prop_types_1.default.bool,
    displayAsRow: prop_types_1.default.bool,
};
var defaultProps = {
    price: undefined,
    hasDiscounts: undefined,
    displayAsRow: false,
};
function CarsItemPrice(props) {
    var price = props.price, currency = props.currency, hasDiscounts = props.hasDiscounts, displayAsRow = props.displayAsRow;
    var labelText = hasDiscounts ? 'С учетом выгод' : 'Без учета выгод';
    var currencySymbol = getCurrencySymbol_1.default(currency);
    var displayAsColumn = !displayAsRow;
    var render = (react_1.default.createElement("div", { className: classnames_1.default('azgazui__cars-item-price', 'px-2', {
            'col-12': displayAsRow,
            'col-6': displayAsColumn,
        }) },
        react_1.default.createElement("div", { className: "row align-items-center mx-n2" },
            react_1.default.createElement("div", { className: classnames_1.default('azgazui__cars-item-price-label', 'px-2', {
                    'col-6': displayAsRow,
                    'col-12 mb-1': displayAsColumn,
                }) }, labelText + ":"),
            react_1.default.createElement("div", { className: classnames_1.default('px-2', {
                    'col-6': displayAsRow,
                    'col-12': displayAsColumn,
                }) },
                price && numberFormat_1.default()(price),
                react_1.default.createElement("span", { className: "azgazui__cars-item-price-currency" }, " " + currencySymbol)))));
    return price ? render : null;
}
exports.default = CarsItemPrice;
CarsItemPrice.displayName = 'CarsItemPrice';
CarsItemPrice.propTypes = propTypes;
CarsItemPrice.defaultProps = defaultProps;
